export const DURATION_PICKER_MODE_NAMES = {
  PRESET: 'preset',
  EXACT: 'exact',
} as const;

export const DEFAULT_NIGHTS_PRESET = {
  name: 'week',
  title: 'На неделю',
  value: {
    from: 6,
    to: 8,
  },
};

export const MIN_NIGHTS_COUNT_PACKAGE = 2;
export const MIN_NIGHTS_COUNT_HOTEL = 1;
export const MAX_NIGHTS_COUNT = 30;
